module.exports = __webpack_public_path__ + "img/vuex.288a0dc9.png";